import { applyMiddleware, createStore } from "redux";
import { ADDTOCART } from "./actionsType";
import reducer from "./reducer";

const stockCheckerMiddleWare = store => next => action => {
    const { productStore } = store.getState();
    const product = productStore.find(item => item.name === action.payload.name);
    if (action.type === ADDTOCART && product.availableStock <= 0) {
        alert(`${product.name} is not available right now!`)
    } else {
        next(action);
    }
}
const store = createStore(reducer, applyMiddleware(stockCheckerMiddleWare))
export default store;